<template>
  <section style="flex: 1">
    <div class="d-flex funnel-filter">
      <div class="form-group mr-2">
        <DropdownCheckbox
          v-model="jobFilterDataModel"
          :options="getManagerJobsDropdown"
          @input="handleFunnelJobFilter"
          name="manager-funnel-chart-one"
          placeholder="Jobs"
          label="job_name"
        />
      </div>

      <div class="form-group">
        <!-- TIME RANGE -->
        <TimeRange
          name="manager-funnel-one-time-range"
          @input="handleTimeRangeFilter"
          v-model="timeRangeDataModel"
        />
        <!-- END TIME REANGE -->
      </div>
    </div>

    <VueFunnelGraph
      v-if="values.length"
      :height="thefunnelHeight"
      :width="theFunnelWidth"
      :labels="labels"
      :values="values"
      :colors="colors"
      :sub-labels="subLabels"
      :direction="direction"
      :display-percentage="false"
      subLabelValue="raw"
      :animated="true"
    />

    <div class="spinner-container text-center" v-if="isLoading">
      <svgHelper v-show="isLoading" name="loadingSpinner" class="ml-auto justify-items-center" />
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// import { VueFunnelGraph } from '../../../Admin/Dashboard/vue-funnel-graph';
import { VueFunnelGraph } from 'vue-funnel-graph-js';
import DropdownCheckbox from '@/components/common/DropdownCheckbox/DropdownCheckbox';
import TimeRange from '@/components/common/TimeRange/TimeRange';

import { stagesMixin } from '../../../../mixins/stagesMixin';

export default {
  components: {
    VueFunnelGraph,
    DropdownCheckbox,
    TimeRange,
  },
  mixins: [stagesMixin],
  data: () => ({
    jobFilterDataModel: [],
    timeRangeDataModel: { value: 'all_time', option: 'All time' },
    labels: ['Not contacted', 'Contacted', 'Interviewing', 'Offered employment', 'Employed'],
    subLabels: [],
    values: [],
    colors: [
      ['#f02800', '#f02800'],
      ['#5bb75b', '#5bb75b'],
      ['#0088cc', '#0088cc'],
      ['#913d8b', '#913d8b'],
      ['#043852', '#043852'],
    ],
    width: 800,
    height: 288,
    thefunnelHeight: 200,
    theFunnelWidth: 0,
    direction: 'horizontal',
    gradientDirection: 'horizontal',
    isLoading: false,
    objectZero: {
      102: 0,
      103: 0,
      104: 0,
      106: 0,
      107: 0,
    },
    funnelData: [],
    finalObject: {},
  }),
  methods: {
    ...mapActions('managerStoreModule', ['retrieveManagerFunnelOneData']),
    formatResponse(data) {
      this.finalObject = {};
      this.funnelData = [];

      /* for (const key in data) {
        let title = Object.keys(data[key])[0];
        let currentData = Object.values(data[key])[0];

        if (currentData.length === 0) {
          currentData = {};
        }

        this.finalObject = {
          title,
          data: {
            ...this.objectZero,
            ...currentData,
          },
        };

        this.funnelData.push(this.finalObject);
      } */

      this.funnelData = data.map((item) => {
        return {
          title: item.job_name,
          city: item.city_name,
          data: {
            ...this.objectZero,
            ...item.data,
          },
        };
      });
    },
    handleFunnelJobFilter() {
      this.fetchFunnelOneData(this.jobFilterDataModel, this.timeRangeDataModel.value);
    },
    handleTimeRangeFilter() {
      this.fetchFunnelOneData(this.jobFilterDataModel, this.timeRangeDataModel.value);
    },
    fetchFunnelOneData(jobs, timeRange) {
      /* 
      "Not contacted" - 102
      "Contacted" - 103
      "Interviewing" - 104
      "Offered employment" - 106
      "Offered employment" - 107
      */
      this.isLoading = true;

      this.retrieveManagerFunnelOneData({
        jobads_ids: jobs.map((j) => j.id),
        date: [timeRange],
      })
        .then((res) => {
          this.formatResponse(res.data);

          const tempSubLabels = [];
          const rows = 5;
          const columns = Math.min(5, this.funnelData.length);
          const tempData = [
            [0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0],
          ];

          for (let i = 0; i < rows; i++) {
            for (let j = 0; j < columns; j++) {
              const { title, city, data } = this.funnelData[j];

              const templist = Object.values(data);

              if (j === i) {
                tempSubLabels[i] = `${title}, ${city}`;
              }

              tempData[i][j] = templist[i];
            }
          }

          this.subLabels = tempSubLabels;
          this.values = tempData;

          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    onResizeEventHandler() {},
    debounce: (func, delay) => {
      let timerId;
      return function () {
        clearTimeout(timerId);
        timerId = setTimeout(() => func(this, arguments), delay);
      };
    },
  },
  watch: {
    jobFilterDataModel(newSelectedJobFilterModel) {
      this.localStoragePlugin.set('managerFunnelOneJobSelect', newSelectedJobFilterModel);
    },
    timeRangeDataModel(newSelectedTimeRange) {
      this.localStoragePlugin.set('managerFunnelOneTimeRangeSelect', newSelectedTimeRange);
    },
  },
  computed: {
    ...mapGetters('managerStoreModule', ['getManagerJobsDropdown']),
  },
  mounted() {
    this.theFunnelWidth = document.getElementById('cardu').offsetWidth;

    if (this.localStoragePlugin.has('managerFunnelOneJobSelect')) {
      this.jobFilterDataModel = this.localStoragePlugin.get('managerFunnelOneJobSelect');
    } else {
      this.localStoragePlugin.set(
        'managerFunnelOneJobSelect',
        JSON.stringify(this.jobFilterDataModel),
      );
    }

    if (this.localStoragePlugin.has('managerFunnelOneTimeRangeSelect')) {
      this.timeRangeDataModel = this.localStoragePlugin.get('managerFunnelOneTimeRangeSelect');
    }

    this.fetchFunnelOneData(this.jobFilterDataModel, this.timeRangeDataModel.value);
  },
  created() {
    window.addEventListener('resize', this.debounce(this.onResizeEventHandler, 500));
  },
  destroyed() {
    window.removeEventListener('resize', this.debounce(this.onResizeEventHandler, 500));
  },
  /* watch: {
    values: {
      handler(newVal) {
        console.log('changed: ', newVal);
      },
    },
    deep: true,
    immediate: true,
  }, */
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.funnel-filter {
  display: flex;
  padding: 12px;
  .form-control {
    width: 50%;
    flex-shrink: 0;
  }
  .form-group {
    width: 50%;
    flex-shrink: 0;
  }
  .dropdown-toggle {
    display: block;
    width: 100%;
  }
}

.graphs,
#wrapper {
  overflow: hidden;
  .card-custom {
    margin: 0 0 30px 0 !important;
    height: 420px;
  }
  .row {
    padding-left: 9px;
    padding-right: 9px;
  }
}
.graphs {
  font-family: $font-family-sans-lato !important;
}
</style>
